export default {
  ATA: '到达',
  DEP: '起飞',
  ARR: '落地',
  NDR: '落地',
  CNL: '<i class="red">取消</i>',
  DEL: '<i class="red">延误</i>',
  RTR: '返航',
  SCH: '计划',
  ATD: '推出'
}
